/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_P1Inputs */

const en_wc_tut_keys_p1 = /** @type {(inputs: Wc_Tut_Keys_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft follows Word's shortcuts. On a Mac use ⌘ instead of Ctrl.`)
};

/**
* | output |
* | --- |
* | "WordCraft follows Word's shortcuts. On a Mac use ⌘ instead of Ctrl." |
*
* @param {Wc_Tut_Keys_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_p1 = /** @type {((inputs?: Wc_Tut_Keys_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_p1(inputs)
});
export { wc_tut_keys_p1 as "wc.tut.keys.p1" }